import { useMemo } from 'react';

import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import DefaultPropsProvider from '@mui/material/DefaultPropsProvider';

// Apply MUI's actual fullScreen behavior to every dialog, including library dialogs.
// Explicit desktop fullScreen dialogs and all other theme defaults remain unchanged.
export function ResponsiveDialogDefaults({ children }) {
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const defaults = useMemo(
    () => ({
      ...theme.components,
      MuiDialog: {
        ...theme.components?.MuiDialog,
        defaultProps: {
          ...theme.components?.MuiDialog?.defaultProps,
          ...(mobile && { fullScreen: true }),
        },
      },
    }),
    [theme.components, mobile]
  );

  return <DefaultPropsProvider value={defaults}>{children}</DefaultPropsProvider>;
}
